import React, { useContext, useEffect } from "react"
import { withRouter } from "react-router"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import Button from "@material-ui/core/Button"
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Loading from "../core/Loading";
import AuthContext from "../../context/authentication/authContext"
import { Delete, SaveAltOutlined } from "@material-ui/icons"
import "./bills.css";

const useStyles = makeStyles((theme) => ({
  containerTabs: {
    margin: "auto",
    textAlign: "center",
  },
  tabs: {
    marginLeft: "30px",
    color: "#707070",
    "&:hover": {
      color: "#12b1ee !important",
      borderBottom: "solid 1px #12b1ee",
    },
  },
  title:{
    fontFamily:'Poppins',
    fontStyle:"normal",
    fontWeight:'400',
    fontSize:'32px',
    lineHeight:'20px',
    color:'#001070',
    marginBottom:'46px'
  },

  gridContainer: {
    width:"100%",

},

topButton:{
  display:"flex",
  flexDirection:"row",
  backgroundColor: "#001070",
  color: "#ffffff",
  float: "right",
  padding:"10px, 20px",
  gap: "10px",
  hover:"#001070",
  '&:hover': {
    backgroundColor: '#001070',
    transform: 'translateY(-1px) !important'}

},
button:{
  display:"flex",
  flexDirection:"row",
  backgroundColor: "#001070",
  color: "#ffffff",
  float: "left",
  padding:"10px, 20px",
  gap: "10px",
  '&:hover': {
    backgroundColor: '#001070',
    transform: 'translateY(-1px) !important'}

},
deleteButton:{
  display:"flex",
  flexDirection:"row",
  backgroundColor: "#DA291D",
  color: "#ffffff",
  float: "left",
  padding:"10px, 20px",
  gap: "10px",
  marginRight:"14px",
  '&:hover': {
    backgroundColor: '#DA291D',
    transform: 'translateY(-1px) !important'}

},

  importButton:{

    fontFamily:'Inter',
    fontStyle: 'normal',
    fontWeight:'500',
    fontSize:'14px',
    lineHeight: '20px',
    color:"#ffffff",
    backgroundColor: "#001070",
    textTransform: 'capitalize',
    padding: "10px, 20px",

  },
  tableCell:{
    padding:'5px',
    textAlign:'center',
    color: '#949CA9',

  },
  tableCellTitle:{
    textAlign:'center',
    color: '#000',
    backgroundColor:'#d9d9d9',
    padding:'10px',
    boxShadow: '0px -1px 0px rgba(0, 0, 0, 0.25)',
    border: '1px solid rgba(255, 255, 255, 0.25)',
    borderRadius: '5px',

  },

  inputBillDetail:{

    //border: '1px rgba(232, 233, 234, 1) solid',
    //width:'100%',
    //borderRadius:' 6px',
    padding: '2px',
    //color: '#949CA9',

  }
}))

const NewBillDetails = (props) => {
  const [currentDetail,setCurrentDetail]=React.useState({
    VatToApply:19,
    DiscountPercentage:0
  })
  const classes = useStyles()

  function formatCurrency(value) {
    const formatter = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return formatter.format(value);
  }
  
  function formatNumber(value) {
    if (isNaN(value)) {
      return "";
    }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  function setVat(event){
    setCurrentDetail({
            ...currentDetail,
            VatToApply:event.currentTarget.value==="exento"?0:19
        })
  }
  function _delete(event){
        props.del(event.currentTarget.attributes.detail.value)
  }

  const columns = [
   
    { name: "CODIGO" },
    { name: "PRODUCTO" },
    { name: "CANTIDAD" },
    { name: "UNIDAD" },
    { name: "PRECIO" },
    { name: "DESC." },
    { name: "IMPUESTO" },
    { name: "TIPO" },
    { name: "TOTAL" },
    { name: "ACCIONES" },
  ]

  function addDetail(event){

     const q = [
         document.getElementById('Quantity'),
         document.getElementById('UnitPrice'),
         document.getElementById('DiscountPercentage'),
         document.getElementById('ProductCode'),
         document.getElementById('ProductName'),
         document.getElementById('MeasureUnit'),
         document.getElementById('subtotal')
     ]
     if(   //q[0].value!=='' &&
         q[1].value!==''
      //  && q[2].value!=''
        && q[3].value!==''
        && q[4].value!==''
        && q[5].value!==''
        && q[6].value!==''){
            if(parseInt(q[6].value.replaceAll('$',''))<=0){
                alert('Por favor corriga los datos antes de agregar la fila.')
            }else{
                props.add(currentDetail)
                q.forEach(e=>{
                    e.value=''
                })
                setCurrentDetail({VatToApply:19,  DiscountPercentage:0})
            }
     }else{
        alert('Por favor complete los datos obligatorios antes de agregar la fila a la grilla.')
     }
  }

  function updateField(event){

    try{
        let value = event.currentTarget.value

        switch(event.currentTarget.attributes.name.value){
            case "Quantity":
            case "MeasureUnit":
                const val = parseFloat(event.currentTarget.value)
                if(val <=0){
                    event.currentTarget.value = val*-1
                }
                break;
            case "DiscountPercentage":
            case "UnitPrice":
                value=Math.round(event.currentTarget.value)
                if(value <=0){
                event.currentTarget.value = value*-1
                }
                break;
            default:
                value=event.currentTarget.value

        }

        const q=document.getElementById('Quantity')
        const p = document.getElementById('UnitPrice')
        const d = document.getElementById('DiscountPercentage')

        let total = 0
        if(q&&q.value&&p&&p.value){
            total=Math.round(q.value*p.value)
            if(d&&d.value&&d.value>0){
                let disc = d.value
              //  //console.log('disc',disc)
                total=Math.round(total-total*d.value/100)
                if(total<0){
                    total=0
                }
            }
            /*if(currentDetail.VatToApply>0){
                total=Math.round(total+total*currentDetail.VatToApply/100)
            }*/
        }

        setCurrentDetail({
             ...currentDetail,
             [event.currentTarget.attributes.name.value]:value,
             total
         })
     }catch(error){
        //console.error(error)
     }
  }

  if (!props.data) {
      return <Loading />;
  }
   // //console.log('props',props)
  return (
  <Grid item xs={12}>
    <div className="warning">* Por favor complete todos los campos y presione Agregar antes de emitir el documento</div>
    <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (

                <TableCell
                  key={index}
                  align={column.name === "Monto" ? "right" : "center"}
                  className={classes.tableCellTitle}
                >
                  {column.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>

          <TableRow >
              <TableCell className={classes.inputBillDetail}><input type="text" className="inputBillDetail" onChange={updateField} id="ProductCode" name="ProductCode"/></TableCell>
              <TableCell className={classes.inputBillDetail}><input type="text" className="inputBillDetail" style={{minWidth:'211px'}} onChange={updateField} id="ProductName" name="ProductName"/> </TableCell>
              <TableCell className={classes.inputBillDetail}>
                    <input type="number" className="inputBillDetail" onChange={updateField} id="Quantity" name="Quantity" min="0" step="1"/></TableCell>
              <TableCell className={classes.inputBillDetail}><input type="text" className="inputBillDetail" onChange={updateField} id="MeasureUnit" name="MeasureUnit"/></TableCell>
              <TableCell className={classes.inputBillDetail}>
                 <input type="number"
                        className="inputBillDetail"
                        style={{minWidth:'155px'}}
                        onChange={updateField}
                        id="UnitPrice"
                        name="UnitPrice"
                        min="0"
                        step="1"/> </TableCell>
              <TableCell className={classes.inputBillDetail}>
                <input type="number"
                    min="0"
                    max="100"
                    step="1"
                    id="DiscountPercentage"
                    className="inputBillDetail"
                    onChange={updateField}
                    name="DiscountPercentage"
                    defaultValue={currentDetail.DiscountPercentage}
                 />
              </TableCell>
              <TableCell className={classes.inputBillDetail}><div className="inputBillDetail">{currentDetail.VatToApply}%</div></TableCell>
              <TableCell className={classes.inputBillDetail}>

                <select onChange={setVat} className="inputSelectDetail">
                    <option value="afecto">Afecto</option>
                        <option value="exento">Exento</option>
                </select>

              </TableCell>
              <TableCell className={classes.inputBillDetail}><input className="inputBillDetailSubtotal" id="subtotal" value={typeof currentDetail.total === 'number' ? formatCurrency(currentDetail.total) : ''} readOnly></input></TableCell>
              <TableCell className={classes.inputBillDetail}><Button variant="outlined"  endIcon={<SaveAltOutlined />} onClick={addDetail} style={{color:'#101070'}}>Agregar</Button></TableCell>
              
            </TableRow>

            {props.data.map((n,k) => {
              return (
                <TableRow key={k}>
                  <TableCell className={classes.tableCell}>{n.ProductCode}</TableCell>
                  <TableCell className={classes.tableCell}>{n.ProductName} </TableCell>
                  <TableCell className={classes.tableCell}>{formatNumber( n.Quantity)}</TableCell>
                  <TableCell className={classes.tableCell}>{n.MeasureUnit}</TableCell>
                  <TableCell className={classes.tableCell}> {formatCurrency( n.UnitPrice)} </TableCell>
                  <TableCell className={classes.tableCell}>{n.DiscountPercentage}%</TableCell>
                  <TableCell className={classes.tableCell}>{n.VatToApply}%</TableCell>
                  <TableCell className={classes.tableCell}>{n.VatToApply===0?"Exento":"Afecto"}</TableCell>
                  <TableCell className={classes.tableCell}>{formatCurrency( n.total)}</TableCell>
                  <TableCell className={classes.tableCell}><Delete style={{color:'#DA291D', cursor:'pointer'}
                  } onClick={_delete} detail={k}></Delete></TableCell>
                </TableRow>
              );
            })}

          </TableBody>
        </Table>
      </Paper>
  </Grid>
  )
}

export default withRouter(NewBillDetails)
